import api, { setToken } from '../index';

export function calendarStatus(data) {
  return api.get('/google-calendar/status', setToken(data.token));
}

export function calendarConnect(data) {
  return api.post('/google-calendar/connect', {}, setToken(data.token));
}

export function calendarSync(data) {
  return api.post('/google-calendar/sync', {}, setToken(data.token));
}

export function calendarDisconnect(data) {
  return api.post('/google-calendar/disconnect', {}, setToken(data.token));
}

/** Сітка тижня панелі «Мій календар»: розклад (read-only) + власні події. */
export function calendarWeek(data) {
  return api.get(`/calendar/week?start=${data.start}`, setToken(data.token));
}

export function calendarEventCreate(data) {
  return api.post('/calendar/events', data.event, setToken(data.token));
}

export function calendarEventUpdate(data) {
  return api.patch(`/calendar/events/${data.id}`, data.event, setToken(data.token));
}

export function calendarEventDelete(data) {
  return api.delete(`/calendar/events/${data.id}`, setToken(data.token));
}
